import actions from 'flow/actions';
import { RecordedCallKey } from 'flow/types/EntityKeys';
import { TranscriptionState } from 'flow/types/RecordedCalls';
import { fromJS } from 'immutable';

interface RecordedCallsAction {
    type: string;
    recordedCallKey?: RecordedCallKey;
    transcriptionState?: TranscriptionState;
}

const initialState = fromJS({
    transcriptionProgress: {},
});

export const recordedCallsReducer = (
    state = initialState,
    action: RecordedCallsAction,
) => {
    if (action?.type === actions.RESULT_CALL_RECORDING_TRANSCRIPTION_PROGRESS) {
        const { recordedCallKey, transcriptionState } = action;
        return state.setIn(
            ['transcriptionProgress', recordedCallKey],
            transcriptionState ?? '',
        );
    }
    return state;
};
